import React, { useContext, useState, useEffect, useRef } from 'react';

import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { act } from 'react';
// require("dotenv").config();
import Cookies from 'js-cookie';

const instance = axios.create({
  baseURL: 'http://85.198.9.88:8080',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
    'Access-Control-Allow-Headers':
      'X-Requested-With, Content-Type, Authorization',
    'Access-Control-Allow-Credentials': 'true',
  },
  // timeout: 30000,
  // timeoutErrorMessage: "Time out!",
});

// console.log(process.env.REACT_APP_BASE_URL);
// const url_1 = 'https://45.159.115.117:443/api/data?id=1';
const url_1 = '/api/data?id=1';
const url_2 = '/api/law/index?types=1&size=';
const url_3 = '/api/law/index?types=2&size=';
const url_4 = '/api/law/index?types=3&size=';
const url_5 = '/api/law/index?types=4&size=';

const ApiURL1 = '/api';
// const ApiURL = "https://localhost:7270/api";
const ApiURL = '/api';
const url_org = '/api/data/orgs';
const url_subjects = '/api/data/subjects';

const url_LawTypes = '/api/Data/LawTypes';
const url_CodeGozari = '/api/Data/BaseInfo?cat=5';

const url_base = '/api/Law/Index?';

const url_orgsId = '/api/Data/Orgs?exec=true';
const url_OrgsID_Teitle = '/api/Data/Orgs?IDs=';
const url_orgTree = '/api/data/OrgTree?exec=true';
const url_search1 = '/api/law/index?&search=';
const url_mozomainpage = '/api/law/index?';
// const url_search = "https://localhost:7270/api/advsearch/search?&search=";
// const url_search = "/api/advsearch/search?&search=";
const url_search = '/api/AdvSearch/Search?Search=';
const url_countSearch = '/api/law/index?type=1&search=';
const url_Ostan = '/api/data/locations?type=6';
const url_Shahr = '/api/data/locations?type=7';
const url_Keshvar = '/api/data/locations?type=5';

const url_LoginJWT = `/api/Accounts/Login`;
const url_Production_accessToken_based_refreshToken =
  '/api/Account/RefreshToken';

const url_search_li = '/api/law/text?id=5&';

const url_FTanghih = '/api/law/RelationIndex?';
const url_Status = '/api/data/Status';

// const url_search_section=  'https://ilaw.mrc.ir:2053/api/AdvSearch/SearchSection?lawId=6106&search=&isSynonym=false&parentSelector=false&selector=0&size=10&page=1&isHighlighted=true'

const url_LinkDownKetabsaz =
  '/api/report/book?Title=&search=&fromDate=&toDate=&subjects=&types=&order&size=100';

export const useGlobalContext = () => {
  return useContext(AppContext);
};

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  // if (window) {
  //   window.onbeforeunload = function () {
  //     localStorage.clear();
  //   };
  // }
  const [tokenLogin, setTokenLogin] = useState(() => {
    if (typeof window !== 'undefined') {
      // خواندن مقدار اولیه از لوکال استوریج
      const storedValueToken = localStorage.getItem('tokenLogin');
      const accessTokenNew = JSON.parse(storedValueToken);
      // console.log("accessTokenNew", accessTokenNew);
      // console.log("accessTokenNew.accessToken--->", accessTokenNew.accessToken);
      // console.log("storedValueToken", JSON.parse(storedValueToken));
      // اگر مقدار در لوکال استوریج وجود داشته باشد، از آن استفاده کنید. در غیر اینصورت، از مقدار پیشفرض استفاده کنید.
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });
  // console.log("context",typeof window !== "undefined")
  // console.log("tokenlogin",tokenLogin)
  // const [refreshTokenLogin, setRefreshTokenLogin] = useState(second)

  // const [types,setTypes]=useState(0)

  const [locationKeshvar, setLocationKeshvar] = useState([]);
  // const nav = useNavigate();
  const [modalListTanghih, setModalListTanghih] = useState([]);

  const [txtSearch, setTxtSearch] = useState('');

  const [ShowTimerForLogin, setShowTimerForLogin] = useState(false);
  const [CheckCode, setCheckCode] = useState('');

  const [size, setSize] = useState(10);
  const [SavePageMonaghah, setSavePageMonaghah] = useState(1);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [mogharare, setMogharare] = useState([]);
  const [ray, setRay] = useState([]);
  const [nazar, setNazar] = useState([]);
  const [status, setStatus] = useState([]);
  const [statusE, setStatusE] = useState('');
  const [locationsId, setLocationsId] = useState('');
  const [locationsDataOstan, setLocationsDataOstan] = useState('');
  const [data, setData] = useState([]);

  const [types, setTypes] = useState('');

  const [keyWordSearch, setKeyWordSearch] = useState('');
  const [subjects, setSubjects] = useState('');

  const [dataSubjects, setDataSubjects] = useState([]);
  const [dataOrgs, setDataOrgs] = useState([]);
  const [orgs, setOrgs] = useState('');
  const [dataOrgsId, setDataOrgsId] = useState([]);
  const [orgsId, setOrgsId] = useState('');
  const [resPerPage, setResPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [methodsid, setMethodsid] = useState(1);
  const [isOrder, setIsOrder] = useState(0);

  const [partOfWord, setPartOfWord] = useState(false);

  const [ApproveDate, setApproveDate] = useState('');
  const [toApproveDate, setToApproveDate] = useState('');
  const [daaate, setDaaate] = useState();
  const [toDaaate, setToDaaate] = useState();

  const [searchContent, setSearchContent] = useState(2);

  const [checkedSinoname, setCheckedSinoname] = useState(false);
  const [checkedTypes, setCheckedTypes] = React.useState([
    true,
    true,
    true,
    true,
  ]);

  const [checkedNewType, setCheckedNewType] = useState([]);
  const [expandedNewType, setExpandedNewType] = useState([]);
  const [nodesNewType, setNodesNewType] = useState([]);
  const [codeGozari, setCodeGozari] = useState([]);

  const [checkedAF, setCheckedAF] = React.useState([true, true]);
  const [checkedJostojoEbarat, setCheckedJostojoEbarat] = React.useState([
    true,
    true,
  ]);
  const [selectedOptionDataOrgs, setSelectedOptionDataOrgs] = useState(null);
  const [selectedOptionDataOrgsID, setSelectedOptionDataOrgsID] =
    useState(null);

  const [isRevision, setIsRevision] = useState();

  const [isRepealed, setIsRepealed] = useState();
  const [lawTypeIds, setLawTypeIds] = useState(0);

  const [valueSelector, setValueSelector] = React.useState(0);

  const [pageMozoe, setPageMozoe] = useState(1);
  const [sizeMozoe, setSizeMozoe] = useState(50);

  const [pagejostejo, setPagejostejo] = useState(1);
  const [sizeJostejo, setSizeJostejo] = useState(10);
  const [typeJostejo, setTypeJostejo] = useState(0);

  const [pageEjrae, setPageEjrae] = useState(1);
  const [sizeEjrae, setSizeEjrae] = useState(20);

  const [pageTasvib, setPageTasvib] = useState(1);
  const [sizeTasvib, setSizeTasvib] = useState(30);

  const [pageTanghih, setPageTanghih] = useState(1);
  const [sizeTanghih, setSizeTanghih] = useState(30);
  const [subjectMozo, setSubjectMozo] = useState({});
  const [pageSizeAdvance, setPageSizeAdvance] = useState(10);
  const [pageAdvance, setPageAdvance] = useState(1);

  const [savePage, setSavePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);

  const [Scroll, setScroll] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [flag, setFlag] = useState(0);
  const [typeFlag, setTypeFlag] = useState(false);

  const [ShowText, setShowText] = useState(true);
  const [ShowList, setShowList] = useState(false);

  const [MoreViewLaw, setMoreViewLaw] = useState(false);
  const [MoreViewRegulations, setMoreViewRegulations] = useState(false);
  const [MoreViewVotes, setMoreViewVotes] = useState(false);
  const [MoreViewOpinions, setMoreViewOpinions] = useState(false);
  const [NewTabLaw, setNewTabLaw] = useState(true);
  const [NewTabRegulations, setNewTabRegulations] = useState(true);
  const [NewTabVotes, setNewTabVotes] = useState(true);
  const [NewTabOpinions, setNewTabOpinions] = useState(true);

  const [pageListCount, setPageListCount] = useState(0);
  const [SelectCodeMozoee, setSelectCodeMozoee] = useState(0);
  const [SelectTreeNode, setSelectTreeNode] = useState(0);
  const [Searchtitleid, setsearchtitleid] = useState('');
  const [SHowTimer, setShowTimer] = useState(false);
  const [RegisterCaptcha, setRegisterCaptcha] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [RefreshCaptcha, setRefreshCaptcha] = useState(false);
  const [LoginPage, setLoginPage] = useState(true);
  const [toggleSabt, setToggleSabt] = useState(true);
  const [pIdChapter, setPIdChapter] = useState(0);
  const [chapterSectionText, setChapterSectionText] = useState([]);
  const [titChapterInfo, setTitChapterInfo] = useState({
    ID: 0,
    Title: '',
    Parent_ID: 0,
    Definition: '',
    Code: '0',
    Ordering: 0,
    Type_ID: 0,
    Keywords: '',
    Old_IDs: '',
    MainLaw_IDs: '',
    Section_ID: 0,
    IsActive: false,
    isChecked: false,
  });
  const [CookieToken, setCookieToken] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = Cookies.get('token');
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });
  const [titleSubInfo, setTitleSubInfo] = useState({
    ID: 0,
    Title: '',
    Parent_ID: 0,
    Definition: '',
    Code: '0',
    Ordering: 0,
    Type_ID: 0,
    Keywords: '',
    Old_IDs: '',
    MainLaw_IDs: '',
    Section_ID: 0,
    IsActive: false,
    isChecked: false,
  });
  const isTokenExpired = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      // console.log("decoded", decoded);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };
  const [statistic, setStatistic] = useState([]);

  const GetLocalEdame = () => {
    if (process.env.REACT_APP_EDAME == 'false') {
      // console.log("tokenLogin.accessToken=========>", tokenLogin.accessToken);
      if (
        typeof window !== 'undefined' &&
        isTokenExpired(tokenLogin?.accessToken)
      ) {
        // console.log("trueeeeeeeeeeeee1111111111111111111111");
        let edame = localStorage.getItem('edame');
        // console.log("edame12345", edame);
        if (edame) {
          return JSON.parse(localStorage.getItem('edame'));
        } else {
          return false;
        }
        // return true;
      } else {
        // console.log("trueeeeeeeeeeeee222222222222222222222222");
        let edame = localStorage.getItem('edame');
        // console.log("edame98765", edame);
        // console.log(
        //   "tokenLogin.accessToken-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=->>>>>>>",
        //   tokenLogin.accessToken,
        // );
        if (edame) {
          // console.log("test,test,test,test,test,test,test,test,");
          return JSON.parse(localStorage.getItem('edame'));
        } else {
          // console.log(
          //   "test false,test false,test false,test false,test false,",
          // );
          return false;
        }
        localStorage.clear();
        // return false;
      }
    } else {
      // console.log("first", process.env.REACT_APP_EDAME);
      // console.log("trueeeeeeeeeeeee");
      return true;
    }
  };
  // const [edame, setEdame] = useState(GetLocalEdame());
  const [edame, setEdame] = useState(true);
  const [pathName, setPathName] = useState(window.location.pathname);
  const Logout = () => {
    localStorage.clear();
    Cookies.remove('token');
    setCurrentUser(null);
    setLoading(false);
    window.location.assign(`${pathName == '/login' ? '/' : pathName}`);
  };
  const getLocalStorager = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      let list = localStorage.getItem('list');
      if (list && list !== `undefined`) {
        return JSON.parse(localStorage.getItem('list'));
      } else {
        return [];
      }
    }
  };
  // const id=useParams()
  useEffect(() => {}, []);

  const [swapp, setSwapp] = useState(true);
  const [swappTree, setSwappTree] = useState(true);
  const [IDTree, setIDTree] = useState('');
  const [currentuser, setCurrentUser] = useState(null);
  const [SearchResult, setSearchResult] = useState(getLocalStorager);

  const [law, setLaw] = useState([
    {
      Title: 'عنوان',
      ID: '1',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '2',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '3',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '4',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '5',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '6',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '7',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '8',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '9',

      ApproveDate: '1/1/1',
    },
    {
      Title: 'عنوان',
      ID: '10',

      ApproveDate: '1/1/1',
    },
  ]);
  const [login, setLogin] = useState([]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // const [size, setSize] = useState(10);

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const fetchOrgs = async () => {
    setLoading(true);
    try {
      const org = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_org}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      setDataOrgs(org);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const fetchDataLocation = async () => {
    setLoading(true);
    try {
      const loca = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_Ostan}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      setLocationsDataOstan(loca);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const fetchOrgsId = async () => {
    setLoading(true);
    try {
      const orgId = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_orgsId}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      setDataOrgsId(orgId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const fetchSubject = async () => {
    setLoading(true);
    try {
      const subject = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_subjects}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      // console.log(subject)
      setDataSubjects(subject);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };

  const fetchLawTypes = async () => {
    setLoading(true);
    try {
      const LawTypes = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_LawTypes}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      setNodesNewType(LawTypes);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('errorfetchLawTypes =>', error);
    }
  };

  const fetchCodeGozari = async () => {
    setLoading(true);
    try {
      const CodeGozari = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_CodeGozari}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      // setNodesNewType(CodeGozari);
      setCodeGozari(CodeGozari);
      // console.log("CodeGozari==========>", CodeGozari);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('errorfetchCodeGozari =>', error);
    }
  };

  const fetchStatus = async () => {
    setLoading(true);
    try {
      const status = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_Status}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      setStatus(status);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };

  const fetchLocation_Keshvar = async () => {
    setLoading(true);
    try {
      const keshvar = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}${url_Keshvar}`, {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        })
      ).json();
      // console.log("keshvar",keshvar)
      setLocationKeshvar(keshvar);
      // console.log("keshvar------->", keshvar);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error fetchLocation_Keshvar=>', error);
    }
  };

  // console.log(pathName)
  const router = useNavigate();
  const [LawForUser, setLawForUser] = useState({
    username: '',
    List: [],
  });
  const fetchLoginJWT = async () => {
    setLoading(true);
    try {
      // console.log(email, password);
      const response = await fetch(
        // `${process.env.REACT_APP_NEW_BASE_URL}/v1/Account/Login`,
        `${process.env.REACT_APP_BASE_URL}/api/Account/Login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // "Access-Control-Allow-Origin": "*",
            // "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
            // "Access-Control-Allow-Headers":
            //   "X-Requested-With, Content-Type, Authorization",
            // "Access-Control-Allow-Credentials": "true",
          },
          body: JSON.stringify({
            UserName: `${email}`,
            Password: `${password}`,
          }),
        }
      );
      // console.log(response.json());
      const token = await response.json();
      // console.log("token---1---11---1-->", token);
      // setTokenLogin(token);

      // localStorage.setItem("tokenLogin", JSON.stringify(token));
      // navigate(`${pathName}`)

      setLoading(false);
      if (
        token[0] === 'Password : The Password field is required.' ||
        token[0] === 'user not found' ||
        token[0] === 'UserName : The UserName field is required.' ||
        token[0] === 'you should go to the login.' ||
        token[0] === 'invalid informatiom.' ||
        token.statusCode !== 200
      ) {
        alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
        // console.log("user not found");
        setRefreshCaptcha(true);
      } else {
        // fetchLoginProfileJWT()
        setTokenLogin(token.data);
        localStorage.setItem('tokenLogin', JSON.stringify(token.data));
        // router(`${pathName}`);
        setLawForUser((prev) => ({
          ...prev,
          username: jwtDecode(token.data?.accessToken).userName,
        }));
        setCurrentUser(jwtDecode(token.data?.accessToken));
        window.location.assign(`${pathName == '/login' ? '/' : pathName}`);
      }
    } catch (error) {
      console.log('errorFetchLoginJWT', error);
    }
  };
  const fetchLoginProfileJWT = async () => {
    // const isDevelopment =
    //   process.env.REACT_APP_BASE_URL_PROFILE === "https://my.ilaws.net";
    setLoading(true);
    try {
      // console.log(email, password);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/Account/Login`,
        // `${process.env.REACT_APP_BASE_URL}/api/Account/Login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // "Access-Control-Allow-Origin": "*",
            // "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
            // "Access-Control-Allow-Headers":
            //   "X-Requested-With, Content-Type, Authorization",
            // "Access-Control-Allow-Credentials": "true",
          },
          body: JSON.stringify({
            UserName: `${email}`,
            Password: `${password}`,
          }),
        }
      );
      // console.log(response.json());
      const token = await response.json();
      // console.log("token---1---11---1-->", token);
      // setTokenLogin(token);

      // localStorage.setItem("tokenLogin", JSON.stringify(token));
      // navigate(`${pathName}`)

      setLoading(false);
      if (
        token[0] === 'Password : The Password field is required.' ||
        token[0] === 'user not found' ||
        token[0] === 'UserName : The UserName field is required.' ||
        token[0] === 'you should go to the login.' ||
        token[0] === 'invalid informatiom.' ||
        token.statusCode !== 200
      ) {
        alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
        // console.log("user not found");
        setRefreshCaptcha(true);
      } else {
        const isDevelopment = window.location.hostname === 'localhost';
        const cookieDomain = isDevelopment ? '.localhost' : '.ilaws.net' ;

        Cookies.set('token', `${JSON.stringify(token.data)}`, {
          domain: cookieDomain | '.http://85.198.9.88:8080',
          Secure: !isDevelopment,
          path: '/',
          sameSite: isDevelopment ? 'Lax' : 'Strict',
        });
        const cookietoken = JSON.parse(Cookies.get('token'));
        console.log('tokenContext', cookietoken);
        setCookieToken(cookietoken);
        fetchLoginJWT();
        setLawForUser((prev) => ({
          ...prev,
          username: jwtDecode(token.data?.accessToken).userName,
        }));
      }
    } catch (error) {
      console.log('errorFetchLoginJWT', error);
    }
  };
  // console.log(currentuser)
  const fetchRefreshToken = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Account/RefreshToken`,
        {
          method: 'post',

          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            'Access-Control-Allow-Headers':
              'X-Requested-With, Content-Type, Authorization',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            Token: `${tokenLogin?.refreshToken}`,
            UserName: `${email}`,
          }),
        }
      );
      const token = await response.json();
      setTokenLogin(token);
      // localStorage.setItem("tokenLogin", JSON.stringify(token));
      setLoading(false);
    } catch (error) {
      console.log('errorFetchRefreshToken', error);
    }
  };
  const NewfetchRefreshToken = async () => {
    const CookieToken = JSON.parse(Cookies.get('token'));
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/Account/RefreshTokenRegeneration`,
        {
          method: 'post',

          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            'Access-Control-Allow-Headers':
              'X-Requested-With, Content-Type, Authorization',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            Token: `${CookieToken?.refreshToken}`,
            UserName: `${jwtDecode(CookieToken?.accessToken).userName}`,
          }),
        }
      );
      const token = await response.json();
      Cookies.set('token', `${JSON.stringify(token.data)}`, {
        domain: '.ilaws.net' | '.localhost' | 'http://85.198.9.88:8080',
        Secure: true,
        path: '/',
        sameSite: 'strict',
      });
      const userInfo = jwtDecode(token.data?.accessToken);
      setCurrentUser(userInfo);

      setLoading(false);
    } catch (error) {
      console.log('errorFetchRefreshToken', error);
    }
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${url_1}`,
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        }
      );
      const data = await response.json();

      setData(data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const getTypeTitle = (type) => {
    switch (type) {
      case 1:
        return 'قانون';
      case 2:
        return 'مقرره';
      case 3:
        return 'رأی';
      case 4:
        return 'نظر';
    }
  };

  const fetchLaw = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/law/index?types=1&size=${resPerPage}&page=${currentPage}`,
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        }
      );
      const laws = await response.json();
      // console.log(response)
      setLaw(laws.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const test = JSON.parse(localStorage.getItem('LawInfo') || '[]');

  const ChechLocalStorage = () => {
    // console.log("checkLocalstorage fun")
    // const test= JSON.parse(localStorage.getItem("LawInfo") || "[]");

    let ONE_HOUR = 60 * 60 * 1000; /* ms */
    // console.log(ONE_HOUR);
    const d = new Date();
    let a = [];
    test.forEach((i) => {
      // console.log(Date.parse(d) - Date.parse(i.DateTime)>=ONE_HOUR)
      if (Date.parse(d) - Date.parse(i.DateTime) >= ONE_HOUR) {
        const temp = test.filter((item) => item.DateTime !== i.DateTime);
        a = [...temp];
      }
    });
    if (a.length !== 0) {
      localStorage.setItem('LawInfo', JSON.stringify(a));
    }
    // console.log(Date.parse(d) - Date.parse(t) > ONE_HOUR);
  };
  useEffect(() => {
    if (test.length !== 0) {
      ChechLocalStorage();
    }
  }, [test]);
  // const fetchLaw = useQuery("dataLaw", async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/law/index?types=1&size=${resPerPage}&page=${currentPage}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Origin": "*",
  //           "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
  //           "Access-Control-Allow-Headers":
  //             "X-Requested-With, Content-Type, Authorization",
  //           "Access-Control-Allow-Credentials": "true",
  //         },
  //       },
  //     );
  //     const laws = await response.json();

  //     setLaw(laws);
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log("error =>", error);
  //   }
  // });
  // console.log("fetchLaw", fetchLaw);

  // const fetchLaw = useQuery("dataLaw", () => {
  //   try {
  //     // const response = fetch(
  //     return fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/law/index?types=1&size=${resPerPage}&page=${currentPage}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Origin": "*",
  //           "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
  //           "Access-Control-Allow-Headers":
  //             "X-Requested-With, Content-Type, Authorization",
  //           "Access-Control-Allow-Credentials": "true",
  //         },
  //       },
  //     ).then((res) => res.json());
  //     // const laws = response.json();
  //     // return response.json();

  //     // setLaw(laws);
  //   } catch (error) {
  //     console.log("errorFetchLaw =>", error);
  //   }
  // });
  // console.log("fetchLaw", fetchLaw);

  const fetchMogharare = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${url_3}${resPerPage}&page=${currentPage}`,
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        }
      );
      const mogharar = await response.json();

      setMogharare(mogharar.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const fetchRay = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${url_4}${resPerPage}&page=${currentPage}`,
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        }
      );
      const raay = await response.json();
      setRay(raay.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const fetchNazar = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${url_5}${resPerPage}&page=${currentPage}`,
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        }
      );
      const naza = await response.json();

      setNazar(naza.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  const fetchReportStatistic = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Report/Statistic`,
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          //   "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
          //   "Access-Control-Allow-Headers":
          //     "X-Requested-With, Content-Type, Authorization",
          //   "Access-Control-Allow-Credentials": "true",
          // },
        }
      );
      const statistic = await response.json();

      setStatistic(statistic);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('error =>', error);
    }
  };
  // برای جستجوی پیشرفته
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (isTokenExpired(tokenLogin?.accessToken)) {
      if (isTokenExpired(tokenLogin?.refreshToken)) {
        // setEdame(false);
        setEdame(true);
        // localStorage.setItem("edame", JSON.stringify(false));
        localStorage.clear();
      } else {
        fetchRefreshToken();
      }
    } else {
      try {
        fetchLaw();
        fetchMogharare();
        fetchRay();
        fetchNazar();
        fetchReportStatistic();
        // fetchSub()
      } catch (error) {
        console.log('errorFetchAllData', error);
      }
    }
  }, [edame, currentPage]);

  useEffect(() => {
    if (isTokenExpired(tokenLogin?.accessToken)) {
      if (isTokenExpired(tokenLogin?.refreshToken)) {
        // setEdame(false);
        setEdame(true);
        // localStorage.setItem("edame", JSON.stringify(false));
        localStorage.clear();
      } else {
        fetchRefreshToken();
      }
    } else {
      try {
        fetchData();
        fetchSubject();
        fetchOrgs();
        fetchOrgsId();
        fetchStatus();
        fetchLawTypes();
        fetchCodeGozari();
        fetchDataLocation();
        fetchSub();
        fetchLocation_Keshvar();
      } catch (error) {
        console.log('errorFetchAllData222222222222', error);
      }
    }
  }, [edame]);
  let { id } = useParams();

  const checkEdame = () => {
    if (isTokenExpired(tokenLogin?.accessToken)) {
      if (isTokenExpired(tokenLogin?.refreshToken)) {
        setEdame(true);

        // localStorage.setItem("edame", JSON.stringify(edame));
        localStorage.clear();
      } else {
        // console.log("edame with refreshToken");

        fetchRefreshToken();
      }
    } else {
      try {
        // console.log("check edame true ");
        // localStorage.setItem("edame", JSON.stringify(edame));
      } catch (error) {
        console.log('errorFetchAllData222222222222', error);
      }
    }
  };

  const [SubjectList, setSubjectList] = useState([]);
  const [subId, setSubID] = useState(0);
  const fetchSub = () => {
    // console.log("first");
    // setLoading(true);
    try {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Subjects?metheod=0`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then((data) => setSubjectList(data))
        .finally(() => setLoading(false));
    } catch (error) {
      console.log('error', error);
    }
  };

  const NewRegisterWithPhoneNumberFun = async (userInfo, code) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/Account/RegisterUserWithPhoneNumber`,
        // `${process.env.REACT_APP_NEW_BASE_URL}/v1/Account/RegisterUserWithPhoneNumber`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            firstName: userInfo.fName,
            lastName: userInfo.LName,
            phoneNumber: userInfo.phoneNumber,
            code: code,
          }),
        }
      );
      // console.log(response);
      const token = await response.json();
      if (
        token[0] === 'Password : The Password field is required.' ||
        token[0] === 'user not found' ||
        token[0] === 'UserName : The UserName field is required.' ||
        token[0] === 'you should go to the login.' ||
        token[0] === 'invalid informatiom.' ||
        token.statusCode !== 200
      ) {
        alert('مشکلی پیش آمده لطفا مجدد امتحان کنید');
        // console.log("user not found");
        setRefreshCaptcha(true);
      } else {
        setTokenLogin(token.data);
        // localStorage.setItem("tokenLogin", JSON.stringify(token.data));
        Cookies.set('token', `${JSON.stringify(token.data)}`, {
          // domain: '.ilaws.net',
          domain: '.ilaws.net' | '.localhost' | 'http://85.198.9.88:8080',
          Secure: true,
          path: '/',
          // expires: 30,
          sameSite: 'strict',
        });
        // const cookietoken=JSON.parse(token.data)
        setCookieToken(token.data);
        const userInfo = jwtDecode(token.data?.accessToken);
        setCurrentUser(userInfo);
        router('/');
      }
    } catch (error) {}
  };

  const NewLoginWithPhoneNumber = async (phoneNum, code) => {
    try {
      // console.log(email, password);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/Account/LoginWithPhoneNumber`,
        // `${process.env.REACT_APP_BASE_URL}/api/Account/LoginWithPhoneNumber`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            phoneNumber: `${phoneNum}`,
            code: code,
          }),
        }
      );
      const token = await response.json();
      setLoading(false);
      if (
        token[0] === 'Password : The Password field is required.' ||
        token[0] === 'user not found' ||
        token[0] === 'UserName : The UserName field is required.' ||
        token[0] === 'you should go to the login.' ||
        token[0] === 'invalid informatiom.' ||
        token.statusCode !== 200
      ) {
        alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
        setRefreshCaptcha(true);
      } else {
        console.log('token', token);
        Cookies.set('token', `${JSON.stringify(token.data)}`, {
          // domain: '.ilaws.net',
          domain: '.ilaws.net' | '.localhost' | 'http://85.198.9.88:8080',
          Secure: true,
          path: '/',
          // expires: 30,
          sameSite: 'strict',
        });
        // const cookietoken=JSON.parse(token.data)
        setCookieToken(token.data);
        const userInfo = jwtDecode(token.data?.accessToken);
        setCurrentUser(userInfo);
        // setTokenLogin(token);
        // localStorage.setItem("tokenLogin", JSON.stringify(token.data));
        window.location.assign(`${pathName == '/login' ? '/' : pathName}`);
      }
    } catch (error) {
      console.log('errorFetchLoginJWT', error);
    }
  };
  const [Parents, setParents] = useState([]);
  const [subjectsType, setSubjectsType] = useState([]);
  // const tokenCookie=JSON.parse(Cookies.get('token'))
  const [LwTDataID, setLawTDataID] = useState(null);
  const GetListSubject = async () => {
    try {
      let config = {
        method: 'post',
        // maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/UserLwSubjectList`,
        headers: {
          Authorization: `Bearer ${CookieToken.accessToken}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          filters: {
            pageNumber: 1,
            pageSize: 20,
            isSortAscending: true,
            sortField: '',
            search: '',
          },
          subjectType: 4,
        }),
      };
      await axios.request(config).then((res) => {
        const list = res.data;
        setParents(list.data.items);
      });
    } catch (error) {}
  };

  const [NewSubject, setNewSubject] = useState(false);

  const GetSubjectTypeEnum = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/Global/GetSubjectTypeEnum`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${CookieToken.accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => setSubjectsType(data.data));
    } catch (error) {
      console.log('error', error);
    }
  };
  const [LwTData, setLawTData] = useState([]);

  const [EditView, setEditView] = useState(false);
  const [treeView, setTreeView] = useState(true);

  const fetchDataLwSubjectTree = async (ID) => {
    console.log(ID);

    // const tokenCookie=JSON.parse(Cookies.get('token'))
    try {
      let config = {
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/SubjectsTree`,
        headers: {
          Authorization: `Bearer ${CookieToken.accessToken}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          tabvib: true,
          addroot: true,
          parentId: Number(ID),
        }),
      };
      await axios.request(config).then((res) => {
        const list = res.data;
        console.log('list', list);
        setLawTData(list.data);
        setLoading(false);
      });
    } catch (error) {
      console.log('errorfetchDataSubjectsTree', error);
    }
  };
  return (
    <AppContext.Provider
      value={{
        url_OrgsID_Teitle,
        treeView,
        setTreeView,
        EditView,
        setEditView,
        checkEdame,
        // NewLoginWithPhoneNumberProfile,
        // NewRegisterWithPhoneNumberFunForProfile,
        toDaaate,
        setToDaaate,
        daaate,
        setDaaate,

        pageMozoe,
        setPageMozoe,
        sizeMozoe,
        setSizeMozoe,
        pagejostejo,
        setPagejostejo,
        sizeJostejo,
        setSizeJostejo,
        typeJostejo,
        setTypeJostejo,
        pageEjrae,
        setPageEjrae,
        sizeEjrae,
        setSizeEjrae,
        pageTanghih,
        setPageTanghih,
        sizeTanghih,
        setSizeTanghih,
        pageTasvib,
        setPageTasvib,
        sizeTasvib,
        setSizeTasvib,

        partOfWord,
        setPartOfWord,

        ApiURL1,
        ApiURL,
        url_search1,
        url_search,
        url_mozomainpage,
        url_orgsId,
        getTypeTitle,
        loading,
        setLoading,

        loading2,
        setLoading2,

        size,
        setSize,

        law,
        mogharare,
        ray,
        nazar,
        data,
        email,
        setEmail,
        password,
        setPassword,
        login,
        edame,
        setEdame,

        keyWordSearch,
        setKeyWordSearch,
        subjects,
        setSubjects,

        fetchLoginJWT,
        isTokenExpired,
        fetchRefreshToken,

        tokenLogin,
        setTokenLogin,

        url_2,

        items,
        // expiry,
        // setExpiry,
        SearchResult,
        setSearchResult,
        status,
        setStatus,

        statusE,
        setStatusE,

        txtSearch,
        setTxtSearch,

        dataSubjects,
        setDataSubjects,

        resPerPage,
        setResPerPage,
        dataOrgs,
        dataOrgsId,
        currentPage,
        setCurrentPage,
        orgsId,
        setOrgsId,
        orgs,
        setOrgs,
        methodsid,
        setMethodsid,
        isOrder,
        setIsOrder,

        isRevision,
        setIsRevision,

        isRepealed,
        setIsRepealed,
        lawTypeIds,
        setLawTypeIds,

        searchContent,
        setSearchContent,

        locationsId,
        setLocationsId,
        checkedSinoname,
        setCheckedSinoname,
        checkedTypes,
        setCheckedTypes,

        expandedNewType,
        setExpandedNewType,
        checkedNewType,
        setCheckedNewType,
        nodesNewType,
        setNodesNewType,

        codeGozari,
        setCodeGozari,

        valueSelector,
        setValueSelector,

        checkedAF,
        setCheckedAF,
        checkedJostojoEbarat,
        setCheckedJostojoEbarat,
        selectedOptionDataOrgs,
        setSelectedOptionDataOrgs,
        selectedOptionDataOrgsID,
        setSelectedOptionDataOrgsID,

        ApproveDate,
        setApproveDate,
        toApproveDate,
        setToApproveDate,
        open,
        setOpen,
        handleDrawerOpen,
        modalListTanghih,
        setModalListTanghih,
        swapp,
        setSwapp,
        swappTree,
        setSwappTree,
        IDTree,
        setIDTree,
        url_Ostan,
        url_Shahr,
        url_Keshvar,
        locationsDataOstan,
        url_base,

        types,
        setTypes,

        page,
        setPage,
        setScroll,
        Scroll,

        count,
        setCount,
        flag,
        setFlag,
        statistic,
        typeFlag,
        setTypeFlag,

        subId,
        setSubID,
        savePage,
        setSavePage,
        SubjectList,

        pageSizeAdvance,
        setPageSizeAdvance,
        pageAdvance,
        setPageAdvance,
        pageCount,
        setPageCount,
        setPageListCount,
        pageListCount,

        locationKeshvar,
        setLocationKeshvar,
        SelectCodeMozoee,
        setSelectCodeMozoee,
        setSelectTreeNode,
        SelectTreeNode,
        Searchtitleid,
        setsearchtitleid,
        currentuser,
        setCurrentUser,
        Logout,
        LawForUser,
        setLawForUser,
        SavePageMonaghah,
        setSavePageMonaghah,
        SHowTimer,
        setShowTimer,
        RegisterCaptcha,
        setRegisterCaptcha,
        phoneNum,
        setPhoneNum,
        RefreshCaptcha,
        setRefreshCaptcha,
        NewRegisterWithPhoneNumberFun,
        LoginPage,
        setLoginPage,
        ChechLocalStorage,
        NewLoginWithPhoneNumber,
        ShowTimerForLogin,
        setShowTimerForLogin,
        CheckCode,
        setCheckCode,
        toggleSabt,
        setToggleSabt,
        pIdChapter,
        setPIdChapter,
        titleSubInfo,
        setTitleSubInfo,
        titChapterInfo,
        setTitChapterInfo,
        chapterSectionText,
        setChapterSectionText,
        ShowText,
        setShowText,
        ShowList,
        setShowList,
        fetchLoginProfileJWT,
        NewfetchRefreshToken,
        MoreViewLaw,
        setMoreViewLaw,
        MoreViewRegulations,
        setMoreViewRegulations,
        MoreViewVotes,
        setMoreViewVotes,
        MoreViewOpinions,
        setMoreViewOpinions,
        NewTabLaw,
        setNewTabLaw,
        NewTabRegulations,
        setNewTabRegulations,
        NewTabVotes,
        setNewTabVotes,
        NewTabOpinions,
        setNewTabOpinions,
        CookieToken,
        setCookieToken,
        Parents,
        setParents,
        GetListSubject,
        GetSubjectTypeEnum,
        subjectsType,
        setSubjectsType,
        NewSubject,
        setNewSubject,
        fetchDataLwSubjectTree,
        LwTData,
        setLawTData,
        LwTDataID,
        setLawTDataID,
        // CookieToken,
        // setCookieToken,
        // setStatistic
        // subjectMozo,
        // fetchBtnResult
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
